import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Form, Modal } from "react-bootstrap";

import Cookies from "js-cookie";

import {
  getActionByChapterId,
  saveAction,
} from "../../../../redux/roleManagementReducer/actionsRoleManagement";

import RoleManagementModalItem from "./roleManagementModalItem/roleManagementModalItem";

import styles from "./roleManagementModal.module.css";

const RoleManagementModal = ({ show, onHide, roleName, sectionName, chapterId, chapterPrivId }) => {
  const dispatch = useDispatch();

  const userId = Cookies.get("userId");

  const { actionByChapterId, availableActionByChapterId } = useSelector(
    (state) => state.roleManagementReducer,
  );

  const handleClose = () => {
    onHide();
  };

  const handleOnChange = (item, value) => {
    const data = {
      chapterPrivId: chapterPrivId,
      actionId: item.id,
      privValue: value,
      privUser: Number(userId),
    };

    dispatch(saveAction(data));
  };

  useEffect(() => {
    dispatch(getActionByChapterId(chapterId));
  }, [dispatch]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      fullscreen="lg-down"
      size="lg">
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>Назначение доступа к функционалу</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form>
          <Form.Group className={styles["description"]}>
            <div className={styles["description-name"]}>Наименование роли</div>
            <div className={styles["description-value"]}>{roleName}</div>
          </Form.Group>
          <Form.Group className={styles["description"]}>
            <div className={styles["description-name"]}>Наименование раздела</div>
            <div className={styles["description-value"]}>{sectionName}</div>
          </Form.Group>
          <Form.Group className={styles["permissions"]}>
            {actionByChapterId &&
              actionByChapterId.map((item) => (
                <RoleManagementModalItem
                  key={item.id}
                  item={item}
                  availableActionByChapterId={availableActionByChapterId}
                  onUpdateItem={handleOnChange}
                />
              ))}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}></Modal.Footer>
    </Modal>
  );
};

export default RoleManagementModal;
